// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2d5vr","resendInfoText":"OnGoingPaymentBox_resendInfoText__3-ksr"};